import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getRegistereedCompaniesApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.USER.GET_REGISTERED_COMPANIES,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}